<template>
	<!-- 古代言情 -->
	<div>
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backUrl">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">分类列表</p>
				</div>
			</div>
		</van-sticky>
		<div>
			<van-tabs v-model="active" animated swipeable @change="onChange">
				<van-tab v-for="(item,index) in tabbarLists" :title="item.plate_info_name">
					<!-- 现代言情 -->
					<div class="xiandaiyanqingBox">
						<div v-if="bookInfoList.length == 0" style="text-align: center;margin-top: 100px;">
							<img src="../../assets/img/data_null.png" width="100" alt="">
						</div>
						<div class="blockBox" v-else>
							<div class="blockLeft" 
											v-for="(item,index) in bookInfoList" 
											:key="index"
											@click="go_bookinfo(item.book_id)"
							>
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
									  <!-- <span v-for="(bookName,nameIndex) in item.book_name" v-if="nameIndex <= 14">{{bookName}}</span> -->
									  <!-- <p :style="{width:(item.book_name.length * 1 ) + 'em' }">{{item.book_name}}</p> -->
									  <span class="bookTxtBox" v-if="item.book_name">
									  	<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
									  </span>
									  <span class="bookTxtBox" v-else>
									  	<van-notice-bar scrollable :text="item.book_name"></van-notice-bar>
									  </span>
									  </div>
									<div class="auther">
										<span>{{item.author}}</span>
										<p>
											<span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span>
											<span class="wanjie">{{item.progress_status}}</span>
										</p>
									</div>
									<p class="bookType">{{item.type_list}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="item in item.lable_list">{{item.name}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</van-tab>
			</van-tabs>
		</div>
		<Loading v-show="isLoading"></Loading>
	</div>
</template>

<script>
	export default{
		components:{
		},
		data(){
			return{
				title:'',
				active: 0,
				tabbarLists: [],
				bookInfoList: [],
				plateInfoId: '',
				isLoading: false,
			}
		},
		created(){
			// this.init();
			this.plateInfoId = this.$route.query.plate_info_id;
			if(this.$route.query.plate_info_id){
				this.plateBookList(); //获取列表数据
			}
		},
		methods:{
			backUrl(){
				this.$router.push('/bookcity')
			},
			plateBookList() {
				var _t  = this;
				var id = _t.plateInfoId;
				_t.isLoading = true;
				_t.$axios.post(`${_t.$api.plateBookList}?plate_info_id=${id}`).then(res => {
					if(res.data.code == 1){
						_t.tabbarLists = res.data.data.group_list;
						_t.bookInfoList = res.data.data.plate_list;
						
						// tab选中
						for(var i = 0; i < _t.tabbarLists.length; i++){
							if(id == _t.tabbarLists[i].id){
								_t.active = i;
							}
						}
					}else{
						_t.$toast(res.data.msg);
					}
					_t.isLoading = false;
				})
			},
			onChange(index) {
				var _t = this;
				_t.plateInfoId = _t.tabbarLists[index].id;
				_t.plateBookList();
				// console.log(this.tabbarLists[index].id,this.tabbarLists[index].plate_info_name)
			},
			go_bookinfo(id) {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>


<style>
	.van-tabs__line {
		background-color: transparent;
	}
	.van-tab--active{
		color: #ff4081;
		transform: scale(1.1);
		font-weight: 600;
	}
</style>
<style lang="less" scoped>
	/deep/.van-tabs--line .van-tabs__wrap {
		position: fixed;
		top: 160px;
		z-index: 100;
		width: 100%;
	}
	
	/deep/.van-tabs__content--animated {
		margin-top: 80px;
	}
	/deep/.van-tab__pane, .van-tab__pane-wrapper {
	    -webkit-flex-shrink: 0;
	    flex-shrink: 0;
	    box-sizing: border-box;
	    width: 100%;
	    margin-top: 6px;
	}
	// 头部
	.headerBox {
		height: 160px;
		// background-color: #ff4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		.headerQuery {
			margin-top: 70px;
			padding: 0 16px;
			position: relative;
			display: flex;
			width: 100%;
			height: 90px;
			line-height: 90px;
			color: #000;

			
			.arrImg {
				img {
					width: 40px;
					height: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}
	
	.xiandaiyanqingBox{
		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			padding: 0 16px;
			background-color: #fff;
		
			.blockLeft {
				display: flex;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;
		
				/*no*/
				.book_Img {
					// width: 138px;
					height: 260px;
		
					img {
						display: block;
						float: left;
						width: 155px;
						height: 240px;
						/*px*/
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
					}
				}
		
				.blockBookInfo {
					margin-left: 20px;
					width: calc(100vw - 200px);
					font-size: 26px;
					/*px*/
					line-height: 30px;
		
					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
						/*px*/
						p {
							display: inline-block;
							float: right;
							font-weight: 400;
						
							span {
								margin-left: 8px;
								color: #000;
								font-size: 26px;
								/*px*/
							}
						}
					}
		
					.bookName {
						padding-bottom: 20px;
						font-size: 30px;
						.bookTxtBox {
							width: calc(100vw - 260px);
							font-size: 30px;
							/*px*/
							color: #000;
							overflow: hidden;
							display: inline-block;
							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						
							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								height: 30px;
								padding: 0;
							}
						}
					}
		
					.bookType,
					.introduction {
						padding-top: 20px;
						color: #000;
						opacity: 0.4;
						font-size: 24px;
						/*px*/
					}
		
					.introduction {
						width: 60vw;
						padding-top: 15px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
		
					.book_button {
						margin-top: 15px;
						align-items: center;
		
						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}
		
						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}
		
		}
	}

</style>
